<template>
  <div class="yj ">
    <div class="user-options" v-for="(item, i) in onlineTimeVO" :key="i">
      预警数值: 提升 {{ item.upJudgeVal }} %, 下降 {{ item.downJudgeVal }} %
      <div class="box user-options">
        <div class="left">
          <div class="shen">
            <div>{{ text[i] }}上升{{ i == 3 ? '' : '人数' }}</div>
            <div>
              <span class="font">{{ item.upData.count }}</span> 人
            </div>
            <div @click="list(item.upData.list)">详情 ></div>
          </div>
          <div class="Img">
            <div class="tu">
              <img :src="img(item.upData.rateStr)" alt="" />
              <div>
                {{ texxt }}
                <span
                  :style="item.upData.rateStr > 0 ? 'color:red' : 'color:green'"
                  >{{ item.upData.rateStr }}</span
                >
                %
              </div>
            </div>
            <div class="tu">
              <img src="../assets/imgs/up.png" alt="" />
              <div>
                提升最高值 <span> {{ item.upData.maxRate }}</span> %
              </div>
            </div>
          </div>
        </div>
        <div class="center" style=""></div>
        <div class="left">
          <div class="shen">
            <div>{{ text[i] }}下降{{ i == 3 ? '' : '人数' }}</div>
            <div>
              <span class="font">{{ item.downData.count }}</span> 人
            </div>
            <div @click="list(item.downData.list)">详情 ></div>
          </div>
          <div class="Img">
            <div class="tu">
              <img :src="img(item.downData.rateStr)" alt="" />
              <div>
                {{ texxt }}
                <span
                  :style="item.upData.rateStr > 0 ? 'color:red' : 'color:green'"
                  >{{ item.downData.rateStr }}</span
                >%
              </div>
            </div>
            <div class="tu">
              <img src="../assets/imgs/bo.png" alt="" />
              <div>
                下降最高值 <span>{{ item.downData.maxRate }}</span> %
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible1"
      width="900px"
      :before-close="handleClose"
    >
      <div class="user-options">时间范围:{{ times(platformData) }}</div>
      <div>
        <el-table
          height="60vh"
          :data="tableList"
          style="width: 100%;font-size: 13px;"
        >
          <el-table-column prop="rid" label="主播id" align="center">
          </el-table-column>
          <el-table-column
            prop="beforeData"
            label="前一天/前一周/前一月"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="afterData"
            label="当天/本周/本月"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="riseRateStr"
            align="center"
            label="提升/下降率"
          >
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <div class="dele" @click="del(scope.row.rid)">详请</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose1"
    >
      <div class="user-options">主播id:{{ rid }}</div>
      <div class="user-options">
        时间段:
        <el-date-picker
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
          v-model="formData"
          type="daterange"
          style="width:250px"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button
          style="margin:0 0 0 30px"
          @click="get_list"
          :loading="login"
          type="primary"
          >搜索</el-button
        >
        <el-button
          style="margin:0 30px"
          @click="DownloadFile"
          :loading="login"
          type="primary"
          >下载</el-button
        >
      </div>
      <div>
        <el-table
          height="60vh"
          v-loading="login"
          :data="tableList1"
          style="width: 100%;font-size: 13px;"
        >
          <el-table-column
            prop="date"
            width="100px"
            label="日期"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="rid"
            width="100px"
            label="主播ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            width="100px"
            label="主播昵称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="agentName"
            width="100px"
            align="center"
            label="代理名称"
          >
          </el-table-column>
          <el-table-column
            prop="positiveTime"
            width="100px"
            align="center"
            label="认证时间"
          >
          </el-table-column>
          <el-table-column
            prop="onlineTime"
            width="100px"
            align="center"
            label="在线时长"
          >
          </el-table-column>
          <el-table-column
            width="100px"
            prop="compareYesterdayOnlineTimeRate"
            align="center"
            label="时长环比昨日升降百分比"
          >
          </el-table-column>
          <el-table-column
            prop="flowIncome"
            width="100px"
            align="center"
            label="流量收益"
          >
          </el-table-column>
          <el-table-column
            prop="guaranteeIncome"
            width="100px"
            align="center"
            label="保收收益"
          >
          </el-table-column>
          <el-table-column
            prop="income"
            width="100px"
            align="center"
            label="总收益"
          >
          </el-table-column>
          <el-table-column
            prop="avg7DayIncome"
            width="100px"
            align="center"
            label="近7日均总收益"
          >
          </el-table-column>
          <el-table-column
            prop="compareAvg7DayIncomeRate"
            width="100px"
            align="center"
            label="总收益环比近七日均总收益升降百分比"
          >
          </el-table-column>
          <el-table-column
            prop="compareYesterdayIncomeRate"
            width="100px"
            align="center"
            label="总收益环比昨日总收益升降百分比"
          >
          </el-table-column>
          <el-table-column
            prop="effectiveExposure"
            width="100px"
            align="center"
            label="区域有效曝光"
          >
          </el-table-column>
          <el-table-column
            prop="effectiveCallCount"
            width="100px"
            align="center"
            label="有效拨打次数"
          >
          </el-table-column>
          <el-table-column
            prop="effectiveCallRate"
            width="100px"
            align="center"
            label="有效拨打率"
          >
          </el-table-column>
          <el-table-column
            prop="effectiveCallSuccessRate"
            width="100px"
            align="center"
            label="有效接通率"
          >
          </el-table-column>
          <el-table-column
            prop="every100EffectiveExposureIncome"
            width="100px"
            align="center"
            label="每百次有效曝光的收入"
          >
          </el-table-column>
        </el-table>
      </div>
      <el-row>
        <el-pagination
          :current-page.sync="page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="total"
          :page-size="10"
        ></el-pagination>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/downloadFile.js'
import { datainfor } from '@/utils/formdata.js'
export default {
  data () {
    return {
      formData: datainfor(1),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      text: ['在线时长', '收入', '保收', '流量收入'],
      tableList: [],
      tableList1: [],
      dialogVisible: false,
      dialogVisible1: false,
      login: false,
      page: 1,
      total: 0,
      rid: '',
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 1000 * 60 * 60 * 24
        }
      }
    }
  },
  props: {
    onlineTimeVO: {},
    platformData: {},
    texxt: {}
  },
  mounted () {
    this.times()
  },
  created () {},
  methods: {
    handleCurrentChange (num) {
      this.page = num
      this.get_list()
    },
    handleClose () {
      this.dialogVisible1 = false
    },
    handleClose1 () {
      this.dialogVisible = false
    },
    times (platformData) {
      platformData =
        platformData instanceof Array
          ? `${platformData[0]}` + ' 至 ' + `${platformData[1]}`
          : platformData
      return platformData
    },
    list (num) {
      this.dialogVisible1 = true
      this.tableList = num
    },
    img (num) {
      let a =
        num > 0
          ? require('../assets/imgs/up.png')
          : require('../assets/imgs/bo.png')
      return a
    },
    del (rid) {
      this.rid = rid
      this.formData =
        this.platformData instanceof Array
          ? this.platformData
          : [this.platformData, this.platformData]
      this.get_list()
      this.dialogVisible = true
    },
    async get_list () {
      this.login = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.detail_panel +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          rid: this.rid,
          start: this.formData[0],
          end: this.formData[1],
          page: this.page
        }
      })
      if (res.code != 0) return this.$message.error(res.msg)
      this.tableList1 = res.data.data
      this.total = res.data.total
      this.login = false
    },
    DownloadFile () {
      this.login = true
      this.$axios({
        method: 'GET',
        url:
          this.$store.getters.path.download_panel +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          rid: this.rid,
          start: this.formData[0],
          end: this.formData[1],
        }
      }).then(res => {
        this.$message.success('开始下载')
        this.login = false
        downloadFile(res.data, '监控主播明细'+this.formData[0]+''+this.formData[1]+''+this.rid)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.yj {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  .box {
    white-space: nowrap;
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 38vw;
    height: 35vh;
    border: 2px solid #909399;
    border-radius: 8px;
  }
  .user-options {
    margin-top: 30px;
  }
  .left {
    width: 14.5vw;
    display: flex;
    justify-content: space-between;
    .shen {
      font-size: 0.7vw;
      width: 140px;
      margin: 45px 0 0;
      > div {
        margin: 0 0 30px;
      }
      > :nth-child(2) {
        margin: 0 20px 22px;
      }

      > :nth-child(3) {
        margin: 0 30px;
        cursor: pointer;
        font-size: 0.5vw;
      }
    }
    .Img {
      flex: 1;
      margin: -30px 0 0;
      text-align: center;
      span {
        display: inline-block;
        font-size: 1vw;
      }
    }
    .tu {
      margin: 10px 0 0;
      font-size: 0.7vw;
      white-space: nowrap;
      text-align: center;
      > :nth-child(1) {
        width: 50px;
        height: 50px;
        margin: 0 0 10px;
      }
    }
  }

  .center {
    height: 100px;
    width: 2px;
    background: #909399;
  }

  .font {
    font-size: 1.3vw;
  }
}
</style>
